const STORAGE_KEY = "kd_admin_foreground_order_notifications";

export function readAdminForegroundOrderNotificationsEnabled() {
  if (typeof window === "undefined") {
    return true;
  }
  const v = window.localStorage.getItem(STORAGE_KEY);
  if (v === null) {
    return true;
  }
  return v === "1";
}

export function writeAdminForegroundOrderNotificationsEnabled(enabled) {
  if (typeof window === "undefined") {
    return;
  }
  window.localStorage.setItem(STORAGE_KEY, enabled ? "1" : "0");
}
